var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDrawerSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9922 0.962878C17.9902 0.890878 17.9692 0.822878 17.9502 0.753878C17.9352 0.695878 17.9282 0.636878 17.9032 0.583878C17.8802 0.531878 17.8412 0.489878 17.8072 0.441878C17.7652 0.380878 17.7272 0.319878 17.6732 0.269878C17.6642 0.260878 17.6602 0.248878 17.6502 0.240878C17.6142 0.209878 17.5702 0.198878 17.5312 0.173878C17.4712 0.134878 17.4122 0.0948779 17.3442 0.0688779C17.2772 0.0448779 17.2112 0.0388779 17.1422 0.0288779C17.0942 0.0218779 17.0512 -0.00012207 17.0002 -0.00012207H12.0002C11.4472 -0.00012207 11.0002 0.447878 11.0002 0.999878C11.0002 1.55188 11.4472 1.99988 12.0002 1.99988H14.8262L10.7902 6.70788L6.51419 4.14288C6.09119 3.88688 5.54719 3.98088 5.23119 4.35988L0.23119 10.3599C-0.12181 10.7839 -0.0648097 11.4149 0.35919 11.7679C0.54719 11.9239 0.77319 11.9999 0.99919 11.9999C1.28619 11.9999 1.57019 11.8779 1.76819 11.6399L6.22019 6.29788L10.4852 8.85788C10.9042 9.10888 11.4422 9.02088 11.7592 8.65088L16.0002 3.70288V5.99988C16.0002 6.55188 16.4472 6.99988 17.0002 6.99988C17.5532 6.99988 18.0002 6.55188 18.0002 5.99988V0.999878C18.0002 0.986878 17.9932 0.975878 17.9922 0.962878Z",
    fill: "#668598"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerSales);
export default __webpack_public_path__ + "static/media/DrawerSales.7dda969a.svg";
export { ForwardRef as ReactComponent };